// Need to use the React-specific entry point to import createApi
import { baseApi } from "./baseApi";

// using CSRF token from Local Storage

// Define a service using a base URL and expected endpoints
export const superVisorApi = baseApi.injectEndpoints({
  reducerPath: "superVisorApi",
  endpoints: (builder) => ({
    getAllSuperVisor: builder.query({
      query: (query) => {
        let queryString = new URLSearchParams(query).toString();
        return {
          url: `get-all-supervisior?${queryString}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      providesTags: ["supervisior"],
    }),
    getAllSuperVisorRoutes: builder.query({
      query: (query) => {
        let queryString = new URLSearchParams(query).toString();
        return {
          url: `routes?${queryString}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      providesTags: ["supervisior"],
    }),
    getAllSuperVisorRoutesStop: builder.query({
      query: (query) => {
        let queryString = new URLSearchParams(query).toString();
        return {
          url: `route-stops?${queryString}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      providesTags: ["supervisior"],
    }),

    addSuperVisor: builder.mutation({
      query: (modifiedData) => {
        return {
          url: `create-supervisior`,
          method: "POST",
          body: modifiedData,
        };
      },
      invalidatesTags: ["supervisior"],
    }),
    updateSuperVisor: builder.mutation({
      query: ({ id, modifiedData }) => {
        return {
          url: `update-supervisior/${id}`,
          method: "PATCH",
          body: modifiedData,
        };
      },
      invalidatesTags: ["supervisior"],
    }),
    deleteSuperVisor: builder.mutation({
      query: (id) => {
        return {
          url: `delete-user/${id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["supervisior"],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAllSuperVisorQuery,
  useAddSuperVisorMutation,
  useUpdateSuperVisorMutation,
  useDeleteSuperVisorMutation,
  useGetAllSuperVisorRoutesQuery,
  useGetAllSuperVisorRoutesStopQuery,
} = superVisorApi;
